/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface V1GetRegionByLatLngResponse
 */
export interface V1GetRegionByLatLngResponse {
    /**
     * 
     * @type {string}
     * @memberof V1GetRegionByLatLngResponse
     */
    regionId: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetRegionByLatLngResponse
     */
    regionName1: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetRegionByLatLngResponse
     */
    regionName2: string;
    /**
     * 
     * @type {string}
     * @memberof V1GetRegionByLatLngResponse
     */
    regionName3: string;
}

/**
 * Check if a given object implements the V1GetRegionByLatLngResponse interface.
 */
export function instanceOfV1GetRegionByLatLngResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "regionId" in value;
    isInstance = isInstance && "regionName1" in value;
    isInstance = isInstance && "regionName2" in value;
    isInstance = isInstance && "regionName3" in value;

    return isInstance;
}

export function V1GetRegionByLatLngResponseFromJSON(json: any): V1GetRegionByLatLngResponse {
    return V1GetRegionByLatLngResponseFromJSONTyped(json, false);
}

export function V1GetRegionByLatLngResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1GetRegionByLatLngResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'regionId': json['region_id'],
        'regionName1': json['region_name1'],
        'regionName2': json['region_name2'],
        'regionName3': json['region_name3'],
    };
}

export function V1GetRegionByLatLngResponseToJSON(value?: V1GetRegionByLatLngResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'region_id': value.regionId,
        'region_name1': value.regionName1,
        'region_name2': value.regionName2,
        'region_name3': value.regionName3,
    };
}

